import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import configureStore from './state/configureStore';
import App from './pages/App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './resources/styles/global.scss';
import '../node_modules/antd/dist/reset.css';
import './resources/styles/global.scss';
import './reset.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MetamaskLayout from './layouts/MetamaskLayout';
import { SolanaProvider } from './components/SolanaProvider';
import GoogleMapProvider from './components/GoogleMap/GoogleMapProvider';
import { ConfigProvider } from 'antd';

const container = document.getElementById('root');
const root = createRoot(container);

const theme = {
  token: {
    fontFamily: "'Fredoka', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
};

root.render(
  <React.StrictMode>
    <ConfigProvider theme={theme}>
      <SolanaProvider>
        <MetamaskLayout>
          <Provider store={configureStore()}>
            <ToastContainer />
            <GoogleMapProvider>
              <App />
            </GoogleMapProvider>
          </Provider>
        </MetamaskLayout>
      </SolanaProvider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
